module.exports = __webpack_public_path__ + "img/lead-safari.1b46c9e0.svg";